import { Base } from "../../framework/base";
import { AppChartType } from "../enums";
import { TaskTypeChartGroupingField } from "./taskTypeChartGroupingField";
import { TaskTypeChartValueField } from "./taskTypeChartValueField";

export interface ITaskTypeChart {
    taskChartType: AppChartType;
    name: string;
    title: string;
    groupingFields: TaskTypeChartGroupingField[];
    valueFields: TaskTypeChartValueField[];
}

export class TaskTypeChart implements ITaskTypeChart {
    taskChartType: AppChartType;
    name: string;
    title: string;
    groupingFields: TaskTypeChartGroupingField[];
    valueFields: TaskTypeChartValueField[];

    constructor();
    constructor(obj: ITaskTypeChart);
    constructor(obj?: any) {
        this.taskChartType = obj && obj.taskChartType || AppChartType.BarChart;
        this.name = obj && obj.name || "";
        this.title = obj && obj.title || "";
        this.groupingFields = obj?.groupingFields || [];
        this.valueFields = obj?.valueFields || [];
    }

    private static createTaskTypeChart(key: string, value: any, taskChartType: AppChartType): TaskTypeChart {
        const result = new TaskTypeChart();
        result.taskChartType = taskChartType;
        result.name = key;
        result.title = !Base.isNullOrUndefined(value.title) ? (value.title as string) : "";
        result.groupingFields = !Base.isNullOrUndefined(value.groupingFields) ? value.groupingFields as TaskTypeChartGroupingField[] : [];
        result.valueFields = !Base.isNullOrUndefined(value.valueFields) ? value.valueFields as TaskTypeChartValueField[] : [];
        for (const groupingField of result.groupingFields) {
            if (Base.isNullOrUndefined(groupingField.sortOrderIsDesc)) {
                groupingField.sortOrderIsDesc = false;
            }
        }
        return result;
    }

    private static getTaskTypeChartFromJsonSchema(key: string, value: any): TaskTypeChart {
        if (!key || !value) return null;
        let result: TaskTypeChart;
        let type = !Base.isNullOrUndefined(value.type) ? (value.type as string) : "";
        type = type ?? "";
        if (type.equalIgnoreCase("linechart")) {
            result = TaskTypeChart.createTaskTypeChart(key, value, AppChartType.LineChart);
            return result;
        }
        if (type.equalIgnoreCase("barchart")) {
            result = TaskTypeChart.createTaskTypeChart(key, value, AppChartType.BarChart);
            return result;
        }
        if (type.equalIgnoreCase("piechart")) {
            result = TaskTypeChart.createTaskTypeChart(key, value, AppChartType.PieChart);
            return result;
        }
        return null;
    }

    static getTaskTypeChartsFromJsonSchema(schema: any): TaskTypeChart[] {
        const result: TaskTypeChart[] = [];
        for (const prop in schema) {
            if (Object.prototype.hasOwnProperty.call(schema, prop)) {
                const taskTypeChart = TaskTypeChart.getTaskTypeChartFromJsonSchema(prop, schema[prop]);
                if (taskTypeChart) {
                    result.push(taskTypeChart);
                }
            }
        }
        return result;
    }
}
      
export const getSchemaObjectFromTaskTypeChart = (chart: Partial<ITaskTypeChart>) => ({
    type: AppChartType[chart.taskChartType].toLowerCase(),
    title: chart.title,
    groupingFields: chart.groupingFields,
    valueFields: chart.valueFields
});
